/* app/js/src/components/common/rectangle-f/rectangle-f.component.scss */
.cursor-pointer {
  cursor: pointer;
}
* {
  box-sizing: border-box;
}
.advanceOption {
  display: flex;
  align-items: center;
}
.checkbox-label-settings {
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #7d8fa1;
  text-transform: uppercase;
  margin-left: 3px;
}
.container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: normal;
  -ms-flex-align: normal;
  align-items: normal;
}
.container div {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.container div:first-of-type {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.container div span {
  margin-right: 15px;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #7d8fa1;
}
.container .offset-scale-wrapper {
  width: 227px;
  height: 83px;
  display: flex;
  flex-direction: column;
  flex: 0 !important;
}
.container .offset,
.container .scale {
  flex: 0 !important;
  margin-top: 13px;
  align-items: center;
}
.container .offset-text,
.container .scale-text {
  margin: 0 !important;
  font-size: 12px !important;
  margin-right: 6px !important;
}
.container .scale-text {
  margin-right: 12px !important;
}
.container .scale-input-warpper,
.container .offset-input-warpper {
  flex: 0 !important;
  margin-right: 6px !important;
  align-items: center;
  position: relative;
}
.container .layers {
  align-items: baseline;
  width: 108px;
  height: 24px;
  margin-left: 6px !important;
}
.container .layer-text {
  font-weight: 600;
  font-size: 12px;
  margin: 0 !important;
  margin-right: 4px !important;
}
.container .layer-info {
  margin: 0 !important;
  background-color: #cdd4db;
  border-radius: 50%;
  border: 3px solid #cdd4db;
  font-size: 9px;
  display: flex;
  align-items: center;
  width: 12px;
  height: 12px;
  margin-right: 13px !important;
}
.container .layer-input-warpper {
  align-items: center;
}
.container .layer-input {
  text-align: end;
  width: 74px;
  height: 28px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  padding-left: 18px;
}
.container .layer-input:focus-visible {
  outline: none;
}
.container .type-layer {
  position: absolute;
  display: flex;
  height: fit-content;
  margin: 0 !important;
  align-items: center;
  margin-left: 6px !important;
}
.container .sign {
  width: 10px;
}
.container .type-dropdown {
  width: 115px;
  height: 21px;
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  text-align-last: center;
}
.container .type-dropdown:focus-visible {
  border: 1px solid #e1e6eb;
  border-radius: 4px;
  outline: none;
}
.container .type-dropdown-wrapper {
  margin-top: 39px;
  position: relative;
}
.container .type-dropdown-wrapper:before {
  content: "";
  width: 14px;
  height: 10px;
  border-right: 1px solid #cdd4db;
  border-top: 1px solid #cdd4db;
  position: absolute;
  top: -12px;
}
.container .type-dropdown-wrapper:after {
  content: "";
  width: 14px;
  height: 10px;
  border-bottom: 1px solid #cdd4db;
  border-right: 1px solid #cdd4db;
  position: absolute;
  bottom: 10px;
}
.container .tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black;
}
.container .tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -67px;
  opacity: 0;
  transition: opacity 0.3s;
}
.container .tooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #555 transparent transparent transparent;
}
.container .tooltip {
  margin: 0 !important;
  border-bottom: 0px !important;
}
.container .tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
.container icn-graphics-scale {
  width: 114px;
}
/*# sourceMappingURL=rectangle-f.component.css.map */
